import { keyNodes } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

const phaseStyle: Record<string, string> = {
  起因: 'bg-secondary-100 text-secondary-800',
  发酵: 'bg-accent-100 text-accent-800',
  高潮: 'bg-primary-100 text-primary-700',
  后续: 'bg-background-200 text-foreground-700',
};

export default function KeyNodes() {
  return (
    <section id="overview" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
              OVERVIEW
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关键节点速览
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-500 md:text-right">
            先看这四张卡，用一分钟建立对海角黑料事件四个阶段的整体印象，再进入正文时间线细读。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {keyNodes.map((node, index) => (
            <Reveal key={node.title} delay={index * 80}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300">
                <div className="flex items-center justify-between">
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${
                      phaseStyle[node.tag] ?? 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {node.tag}
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-400">
                    {node.date}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {node.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {node.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}